import { useQuery } from "@tanstack/react-query"

import {
  getDeliveryFormDocuments,
  getDeliveryFormTraceability,
  getDeliveryFormTraceabilityGeo,
} from "@/features/delivery-forms/api/delivery-forms.api"

export const deliveryFormKeys = {
  all: ["delivery-forms"] as const,
  traceability: (id: string | number) =>
    ["delivery-forms", "traceability", String(id)] as const,
  traceabilityGeo: (id: string | number) =>
    ["delivery-forms", "traceability-geo", String(id)] as const,
  documents: (id: string | number) =>
    ["delivery-forms", "documents", String(id)] as const,
}

export function useDeliveryFormTraceability(
  deliveryFormId: string | number | undefined,
) {
  return useQuery({
    queryKey: deliveryFormKeys.traceability(deliveryFormId ?? ""),
    queryFn: () =>
      getDeliveryFormTraceability(deliveryFormId as string | number),
    enabled: !!deliveryFormId,
    staleTime: 60_000,
  })
}

export function useDeliveryFormDocuments(
  deliveryFormId: string | number | undefined,
) {
  return useQuery({
    queryKey: deliveryFormKeys.documents(deliveryFormId ?? ""),
    queryFn: () => getDeliveryFormDocuments(deliveryFormId as string | number),
    enabled: !!deliveryFormId,
    staleTime: 60_000,
  })
}

// Parcel geometry — same lazy pattern as the OT version: only fetched
// when the parcels tab opens, since polygons can be hundreds of points
// each.
export function useDeliveryFormTraceabilityGeo(
  deliveryFormId: string | number | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: deliveryFormKeys.traceabilityGeo(deliveryFormId ?? ""),
    queryFn: () =>
      getDeliveryFormTraceabilityGeo(deliveryFormId as string | number),
    enabled: !!deliveryFormId && (options?.enabled ?? true),
    staleTime: 60_000,
  })
}
